import { render } from "./paginatorMs.vue?vue&type=template&id=25d3a16e"
import script from "./paginatorMs.vue?vue&type=script&lang=js"
export * from "./paginatorMs.vue?vue&type=script&lang=js"

import "./paginatorMs.vue?vue&type=style&index=0&id=25d3a16e&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__